import { createSelector } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { IFeatureDataState } from '../state/featureData.state';

const FeatureData = (state: IAppState) => state.features;

export const selectFeatures = createSelector(FeatureData, (state: IFeatureDataState) => state.featuresList);

export const selectFeaturesLoaded = createSelector(FeatureData, (state: IFeatureDataState) => state.loaded);
